const columnWidths: Record<string, Record<string, number>> = {
    hr: {
        internalAppPropertyId: 130,
        sellerName: 180,
        sellerOib: 120,
        buyerName: 180,
        buyerOib: 120,
        propertyType: 150,
        propertyLocation: 180,
        propertyStreet: 150,
        area: 120,
        energyClass: 150,
        propertyRegistryInsert: 100,
        propertyRegistrySubinsert: 100,
        propertyCadastralParcelNo: 120,
        propertyCadastralMunicipality: 170,
        price: 120,
        priceM2: 120,
        contractType: 150,
        commissionSeller: 130,
        commissionBuyer: 130,
        commissionPayer: 180,
        conclusionPlace: 180,
        conclusionDate: 170,
        bussniesStatus: 150,
        actions: 100,
    },
    // Add locale overrides below — only specify columns that differ from hr.
    sl: {
        propertyType: 170,
    },
    en: {},
    de: {},
    it: {},
}

export default columnWidths
